import { assetUrl } from '@utils/assetUrl'

export const SOUND_FILES = {
  CLICK: assetUrl('audio/sounds/CLICK.mp3'),
  WON: assetUrl('audio/sounds/WON.mp3'),
  LOST: assetUrl('audio/sounds/LOST.mp3'),
}
